import { TellescopeFormFieldBaseProps } from "../types";
import { Slider } from "@tellescope/ui";
import { cn } from "@tellescope/utils";
import { useTranslation } from "react-i18next";

export interface RatingFieldProps extends TellescopeFormFieldBaseProps<"rating"> {}

export const RatingField = ({ title, value, onChange, className, error, touched }: RatingFieldProps) => {
  const { t } = useTranslation("forms");
  const showError = !!(error && touched);

  return (
    <div className={cn("space-y-2", className)}>
      {title && <h4>{title}</h4>}
      <div className="flex items-center gap-4">
        <span className="text-sm text-muted-foreground">{t("1")}</span>
        <Slider
          value={[value ?? 5]}
          onValueChange={(newVal) => onChange(newVal[0])}
          min={1}
          max={10}
          step={1}
          className="flex-1"
        />
        <span className="text-sm text-muted-foreground">{t("10")}</span>
      </div>
      {value !== undefined && <div className="text-center text-sm text-muted-foreground">{value}</div>}
      {showError && <p className="text-sm text-destructive mt-1">{error}</p>}
    </div>
  );
};
